export enum GisModuleKind {
  OrderHistory = 1,
  OpenOrders = 2,
  DeliveryNotes = 3,
  Invoices = 4,
  OutstandingItems = 5,
  ProductReturns = 6,
  ProductWarranty = 7
}
